//I've decided to do this page NOT by venue, but just a long list
import React, { useState, useEffect, useContext } from 'react'
import './FullSchedule.css'
import { useParams, Link, NavLink } from 'react-router-dom'
import { AuthContext } from '../context/auth-context'
import Footer from '../components/UIElements/Footer'
import SchedulesHomeNavigation from '../components/Navigation/SchedulesHomeNavigation'
import SearchByLeagueOrVenue from '../components/UIElements/SearchByLeagueOrVenue'
import FilterByTeam from '../components/UIElements/FilterByTeam'
import FilterByTeamOrDivision from '../components/UIElements/FilterByTeamOrDivision'
import LoadingSpinner from '../components/UIElements/LoadingSpinner'
import Banner from '../../shared/components/Navigation/Banner'

const LeagueSchedule = () => {
	console.log('inside LeagueSchedule')

	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState()
	const [allLeagueGames, setAllLeagueGames] = useState([])
	const [divisionName, setDivisionName] = useState()

	const leagueId = useParams().leagueId

	const auth = useContext(AuthContext)

	const [isMobile, setIsMobile] = useState(window.innerWidth <= 440)

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 440)
		}

		window.addEventListener('resize', handleResize)
		return () => window.removeEventListener('resize', handleResize)
	}, [])

	//Get all games for the entire League (all teams).  getLeagueSchedule in the league-controller
	useEffect(() => {
		//console.log('INSIDE USE EFFECT')
		const sendRequest = async () => {
			setIsLoading(true)
			setAllLeagueGames([])
			try {
				const response = await fetch(
					`${process.env.REACT_APP_BACKEND_URL}/league/schedule/${leagueId}`,
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setAllLeagueGames(responseData.allLeagueGamesArray)
				setDivisionName(responseData.divisionName)

				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [leagueId])
	//
	//
	//
	//
	const errorHandler = () => {
		setError(null)
	}
	//
	//
	//
	//
	//
	if (isLoading) {
		return (
			<div className='center' style={{ marginTop: '10rem' }}>
				<LoadingSpinner />
			</div>
		)
	}
	//
	//
	let distinctVenues
	let distinctVenuesArray = []

	if (allLeagueGames.length !== 0) {
		distinctVenues = [...new Set(allLeagueGames.map((x) => x.venueName))]
		for (let i = 0; i < distinctVenues.length; i++) {
			distinctVenuesArray.push(distinctVenues[i])
		}
	}
	//
	//
	let dateBlock
	dateBlock = []
	if (!isLoading && allLeagueGames.length === 0) {
		return (
			<React.Fragment>
				<SchedulesHomeNavigation />
				{/* <FilterByTeam /> */}
				{!isMobile && (
					<div style={{ marginTop: '5rem' }}>
						<Banner />
					</div>
				)}
				<FilterByTeamOrDivision />
				<div className='Leagues'>
					<h1>NOTHING SCHEDULED YET!</h1>
				</div>
				<div style={{ marginTop: '16rem' }}>
					<Footer />
				</div>
			</React.Fragment>
		)
	}
	if (
		!isLoading &&
		allLeagueGames.length !== 0 &&
		distinctVenuesArray.length > 0
	) {
		distinctVenuesArray.forEach((venue) => {
			dateBlock.push(
				<div className='Schedule' style={{ marginTop: '1rem' }} key={venue}>
					{!divisionName && (
						<h1>
							{allLeagueGames[0].leagueName + ' - ' + allLeagueGames[0].year}
						</h1>
					)}
					{divisionName && (
						<h1>
							{allLeagueGames[0].leagueName +
								' - ' +
								divisionName +
								' Division - ' +
								allLeagueGames[0].session +
								' ' +
								allLeagueGames[0].year}
						</h1>
					)}

					<h1>{venue}</h1>
					<p>(Click on the final score of a game to see a Game Summary)</p>

					<table id='leagueScheduleDisplay'>
						<thead>
							<tr>
								<th>Date/Time</th>
								<th>Division</th>
								<th>Visitor/Home</th>
								<th></th>
								{auth.isLoggedIn && <th></th>}
								<th>Winner</th>
								<th>Score</th>
							</tr>
						</thead>
						<tbody>
							{allLeagueGames.map((game, key) => {
								if (game.venueName === venue) {
									return (
										<tr key={key}>
											<td>
												{game.dayOfWeek}
												{', '}
												{game.date.substr(0, 2) === '01' &&
													'Jan. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '02' &&
													'Feb. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '03' &&
													'Mar. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '04' &&
													'Apr. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '05' &&
													'May ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '06' &&
													'June ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '07' &&
													'July ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '08' &&
													'Aug. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '09' &&
													'Sept. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '10' &&
													'Oct. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '11' &&
													'Nov. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '12' &&
													'Dec. ' + game.date.substr(3, 2)}
												<br></br>
												{game.time.substr(0, 2) === '00' &&
													'12:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '01' &&
													'1:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '02' &&
													'2:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '03' &&
													'3:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '04' &&
													'4:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '05' &&
													'5:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '06' &&
													'6:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '07' &&
													'7:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '08' &&
													'8:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '09' &&
													'9:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '10' &&
													'10:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '11' &&
													'11:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '12' &&
													'12:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '13' &&
													'1:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '14' &&
													'2:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '15' &&
													'3:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '16' &&
													'4:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '17' &&
													'5:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '18' &&
													'6:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '19' &&
													'7:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '20' &&
													'8:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '21' &&
													'9:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '22' &&
													'10:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '23' &&
													'11:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '24' &&
													'12:' + game.time.substr(3, 2) + ' am'}
											</td>

											{game.divisionName && !game.playoffDivision && (
												<td>{game.divisionName}</td>
											)}
											{game.playoffDivision && <td>{game.playoffDivision}</td>}

											<td>
												{game.visitorTeamSeed > 0 &&
													'(' + game.visitorTeamSeed + ') '}
												{game.visitorTeamName && game.visitorTeamName}
												<br></br>
												{' @ '}
												<br></br>
												{game.homeTeamSeed > 0 &&
													'(' + game.homeTeamSeed + ') '}
												{game.homeTeamName && game.homeTeamName}
												{game.description && (
													<div style={{ color: 'red', fontWeight: 'bold' }}>
														{'('}
														{game.description}
														{')'}
													</div>
												)}
											</td>

											{game.description && <td></td>}
											{!game.playoff && !game.championship && <td></td>}

											{auth.isLoggedIn && (
												<td>
													{game.playoff &&
														!game.championship &&
														game.homeTeamName &&
														(game.homeTeamName === 'TBD' ||
															game.visitorTeamName === 'TBD') && (
															<NavLink
																className='navlinksEnterTeams'
																to={`/admin/updateGame/${game._id}`}
																exact
															>
																TEAMS
															</NavLink>
														)}
												</td>
											)}

											{game.homeTeamId && game.winner === game.homeTeamId && (
												<td>{game.homeTeamName}</td>
											)}
											{game.visitorTeamId &&
												game.winner === game.visitorTeamId && (
													<td>{game.visitorTeamName}</td>
												)}
											{game.status &&
												game.status !== 'TBP' &&
												game.winner !== game.homeTeamId &&
												game.winner !== game.visitorTeamId && <td>TIE</td>}
											{!game.score && <td></td>}

											<td>
												{game.score && (
													<Link
														style={{
															textDecoration: 'none',
															fontWeight: 600,
															color: 'black',
														}}
														to={`/gameSummary/${game._id}`}
													>
														{game.score}
													</Link>
												)}
											</td>
										</tr>
									)
								}
								return null
							})}
						</tbody>
					</table>
				</div>,
			)
		})
	}

	return (
		<div style={{ overflowX: 'hidden' }}>
			<React.Fragment>
				<SchedulesHomeNavigation leagueId={leagueId} />
				{!isMobile && (
					<div style={{ marginTop: '5rem' }}>
						<Banner />
					</div>
				)}
				<FilterByTeamOrDivision />
				{dateBlock && dateBlock}
				<Footer />
			</React.Fragment>
		</div>
	)
}

export default LeagueSchedule
